import { render, staticRenderFns } from "./CombinationOptionInfoForm.vue?vue&type=template&id=2a917cf8&scoped=true&"
import script from "./CombinationOptionInfoForm.vue?vue&type=script&lang=ts&"
export * from "./CombinationOptionInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./CombinationOptionInfoForm.vue?vue&type=style&index=0&id=2a917cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a917cf8",
  null
  
)

export default component.exports